// NOTE: Please format dates like YYYY-MM-DD
export const otherVideos = [
    {
        name: "StuyRavers - RSG Talent Show 2011",
        date: "2011-06-16",
        videoLink: "https://www.youtube.com/embed/tGQBIh4O95Q",
    },
    {
        name: "StuyFlow End of Year Party Collab",
        date: "2016-07-23",
        videoLink: "https://www.youtube.com/embed/aVgvt6MxFTg",
    },
    {
        name: "StuyFlow Performance Compilation 2020",
        date: "2020-07-26",
        videoLink: "https://www.youtube.com/embed/dDQY_n1HuIM",
    },
    {
        name: "StuyFlow Performance Compilation 2019",
        date: "2019-09-17",
        videoLink: "https://www.youtube.com/embed/fOsfJFPSlkg",
    },
    {
        name: "Fire Spinning Montage 🔥🔥🔥 June 2019",
        date: "2019-07-05",
        videoLink: "https://www.youtube.com/embed/3DtlpL0HCp0",
    },
    {
        name: "StuyFlow Trailer 2019",
        date: "2019-07-06",
        videoLink: "https://www.youtube.com/embed/PRFqmy2ldo4",
    },
    {
        name: "StuyFlow Trailer 2019 pt. 2",
        date: "2019-07-06",
        videoLink: "https://www.youtube.com/embed/dJEBnKKMA6E",
    },

]
